import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeSection } from './ResumeSection';

interface Props {
  experiences: BuiltResume['experiences'];
  ats?: boolean;
  executive?: boolean;
}

export function ExperienceSection({ experiences, ats = false, executive = false }: Props) {
  if (!experiences.length) return null;

  return (
    <ResumeSection title="Professional Experience">
      <div className="resume-experience-list">
        {experiences.map((exp) => (
          <article key={`${exp.company}-${exp.dates}`} className="resume-experience-item">
            <div className="resume-experience-header">
              <div>
                <h3 className="resume-experience-role">{exp.role}</h3>
                <p className="resume-experience-company">
                  {exp.company} · {exp.focus}
                </p>
              </div>
              <div className="resume-experience-meta">
                <span>{exp.dates}</span>
                <span>{exp.employmentType}</span>
                <span>{exp.location}</span>
              </div>
            </div>
            {!ats && !executive && <p className="resume-experience-description">{exp.description}</p>}
            <ul className="resume-bullet-list">
              {exp.achievements.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            {exp.technologies.length > 0 && !executive && (
              <p className="resume-tech-line">
                <strong>Technologies:</strong> {exp.technologies.join(', ')}
              </p>
            )}
          </article>
        ))}
      </div>
    </ResumeSection>
  );
}
